import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";
import { FullWidthLayout } from "@/layouts";
import { Step, StepButton, Stepper } from "@mui/material";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { ButtonMui } from "@/components/ui";
import * as Styled from "./Stepsv2.styles";

export const Stepsv2 = () => {
  const { t } = useTranslation("global");
  const [activeStep, setActiveStep] = useState(1);
  const itemsSteps = [1, 2, 3, 4];

  const { windowSize } = useWindowDimensions();

  const [cards, setCards] = useState<any>({
    card1: 0,
    card2: 0,
    card3: 0,
    card4: 0,
  });

  const scrollRef = useRef<any>(null);

  const [scrollPosition, setScrollPosition] = useState(0);

  var windowHeight = windowSize.height;

  const refs: any = useRef(
    Array(itemsSteps.length)
      .fill(null)
      .map(() => React.createRef())
  );

  const handleScroll = () => {
    if (refs.current) {
      refs.current[0].current &&
        setCards({
          card1: refs.current[0].current.getBoundingClientRect().top,
          card2: refs.current[1].current.getBoundingClientRect().top,
          card3: refs.current[2].current.getBoundingClientRect().top,
          card4: refs.current[3].current.getBoundingClientRect().top,
        });
    }

    if (scrollRef.current) {
      setScrollPosition(scrollRef.current.getBoundingClientRect().top);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [cards]);

  const itemSx = {
    "& .MuiSvgIcon-root": {
      color: "transparent",
      border: "1px solid var(--on-surface-dark)",
      borderRadius: "50%",
      padding: "0.2rem",
      "& .MuiStepIcon-text": {
        fill: "var(--on-surface-dark)",
      },
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: "transparent !important",
      border: "1px solid var(--primary-dark) !important",
      "& .MuiStepIcon-text": {
        fill: "var(--primary-dark)",
      },
    },
  };

  return (
    <FullWidthLayout id="steps" bgColor="var(--background-light)">
      <Styled.CardInnerContainer id="boxFreeTrial">
        <Styled.AnimationSection
          offset={scrollPosition}
          ref={scrollRef}
          windowHeight={windowHeight}
        >
          {itemsSteps.map((step, i) => (
            <Styled.CardBox
              ref={refs.current[i]}
              offset={cards[`card${step + 1}`]}
              key={i}
              idx={step}
              windowHeight={windowHeight}
            >
              <Styled.NumSelectors
                windowHeight={windowHeight}
                offset={cards.card1}
                lastStep={cards.card4}
              >
                <Stepper orientation="vertical" connector={null}>
                  {itemsSteps.map((item, index) => {
                    return (
                      <Step key={index} active={step === item}>
                        <StepButton
                          sx={itemSx}
                          onClick={() => setActiveStep(item)}
                        />
                      </Step>
                    );
                  })}
                </Stepper>
              </Styled.NumSelectors>
              <Styled.ImgContainer afterLine={step !== 1 ? true : false}>
                <img
                  src={`/assets/freeTrial/stepsImg/step${step}.svg`}
                  alt="step"
                  className="animate__animated animate__fadeIn animate__delay-0.8s"
                />
              </Styled.ImgContainer>
              <Styled.TextInnerContainer>
                <div>
                  <p
                    style={{
                      fontFeatureSettings: "tnum",
                      fontVariantNumeric: "tabular-nums",
                      color: "var(--primary-dark)",
                    }}
                    className="display-large"
                  >
                    0{step}
                  </p>
                </div>
                <Styled.TextBox>
                  <Styled.CardTitle className="display-medium">
                    {t(`freeTrialSteps.step${step}.title`)}
                  </Styled.CardTitle>
                  <Styled.CardDescription className="body-medium">
                    {t(`freeTrialSteps.step${step}.description`)}
                  </Styled.CardDescription>
                  <ButtonMui variant="text" sx={Styled.SxBtn} color="secondary">
                    <a href="#signUp">{t("freeTrialSteps.freeTrial")} </a>
                  </ButtonMui>
                </Styled.TextBox>
              </Styled.TextInnerContainer>
            </Styled.CardBox>
          ))}
        </Styled.AnimationSection>
      </Styled.CardInnerContainer>
    </FullWidthLayout>
  );
};
